module.exports = __webpack_public_path__ + "img/Löschzug_Wasser.3b67eb90.svg";